import { render } from "./AvaluosRegistro.vue?vue&type=template&id=7652828e"
import script from "./AvaluosRegistro.vue?vue&type=script&lang=js"
export * from "./AvaluosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__